import { FormEvent, useState } from 'react'
import { Send } from 'lucide-react'
import { Alerta, Boton, Campo, Dialogo, Entrada, Seleccion } from '../kit'
import { usePedirTraslado, useRecintos } from '../../queries/useInventario'
import { Bien } from '../../types/inventario'
import { mensajeDeError } from '../../utils/errores'
import { SECTOR } from '../../utils/inventario'

/**
 * Pedir que uno o varios bienes se trasladen (rol «Solicita traslados»). Quien administra
 * bienes la aprueba (y entonces se trasladan) o la rechaza; se sigue en Traslados.
 */
export function DialogoSolicitarTraslado({ bienes, onCerrar, onHecho }: { bienes: Bien[]; onCerrar: () => void; onHecho?: () => void }) {
  const recintos = useRecintos()
  const pedir = usePedirTraslado()
  const [destino, setDestino] = useState('')
  const [motivo, setMotivo] = useState('')
  const origenes = new Set(bienes.map((b) => b.recinto?.codigo))
  const opciones = (recintos.data ?? []).filter((r) => r.activo && !(origenes.size === 1 && origenes.has(r.codigo)))

  const guardar = (e: FormEvent) => {
    e.preventDefault()
    pedir.mutate(
      { bienes: bienes.map((b) => b.id), destino, motivo },
      {
        onSuccess: () => {
          onHecho?.()
          onCerrar()
        },
      },
    )
  }

  const titulo = bienes.length === 1 ? `Solicitar traslado de ${bienes[0].numero || bienes[0].descripcion}` : `Solicitar traslado de ${bienes.length} bienes`
  return (
    <Dialogo abierto onCerrar={onCerrar} titulo={titulo}>
      <form className="pila" onSubmit={guardar}>
        {bienes.length > 1 && (
          <p className="texto-secundario">
            {bienes.slice(0, 4).map((b) => b.numero || b.descripcion).join(', ')}
            {bienes.length > 4 && ` y ${bienes.length - 4} más`}
          </p>
        )}
        <Campo etiqueta="Oficina de destino" requerido>
          <Seleccion value={destino} onChange={(e) => setDestino(e.target.value)} required>
            <option value="">{recintos.isLoading ? 'Cargando…' : 'Elige la oficina'}</option>
            {opciones.map((r) => (
              <option key={r.codigo} value={r.codigo}>
                {r.nombre} · {SECTOR[r.sector]}{r.piso != null ? ` ${r.piso}` : ''} ({r.codigo})
              </option>
            ))}
          </Seleccion>
        </Campo>
        <Campo etiqueta="Motivo" requerido ayuda="Por qué hay que trasladarlos. Lo ve quien aprueba.">
          <Entrada value={motivo} onChange={(e) => setMotivo(e.target.value)} required data-autofocus />
        </Campo>
        <p className="texto-secundario">Los bienes no se mueven hasta que alguien que administra bienes apruebe la solicitud.</p>
        {pedir.isError && <Alerta tipo="error">{mensajeDeError(pedir.error)}</Alerta>}
        <div className="acciones-formulario">
          <Boton variante="text" onClick={onCerrar}>Cancelar</Boton>
          <Boton type="submit" icono={Send} cargando={pedir.isPending} disabled={!destino || !motivo.trim()}>Solicitar</Boton>
        </div>
      </form>
    </Dialogo>
  )
}
